import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AuthContext from "./Context/AuthContext";
//css imports
import "./index.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthContext>
    <App />
  </AuthContext>
);

export const url = "http://localhost:8500/api";

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
